import React, { FC } from "react";
import { startCase } from "lodash";
import { CustomFieldText } from "../../../components/fields/CustomFieldText/CustomFieldText";

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  type?: string;
  disabled?: boolean;
}

export const InputField: FC<Props> = ({ required = true, type, label, ...rest }) => (
  <CustomFieldText {...rest} fullWidth type={ type } label={label || startCase(rest.name)} required={required} />
);
